import axios from '../plugins/axios'

const getPendingApprovals = (params) => axios.get('/approval/pending', { params })
const getApprovalHistory = (params) => axios.get('/approval/history', { params })
const approveProcess = (processId, comments) => axios.post(`/approval/${processId}/approve`, { comments })
const rejectProcess = (processId, comments) => axios.post(`/approval/${processId}/reject`, { comments })
const submitToApproval = (processId) => axios.post(`/approval/${processId}/submit`)

export { getPendingApprovals, getApprovalHistory, approveProcess, rejectProcess, submitToApproval }
